import type { IsSiteAdminFragment } from './__types__/IsSiteAdminFragment';

export const getIsSiteAdminFromQuery = (queryData: IsSiteAdminFragment | undefined): boolean =>
	Boolean(queryData?.isSiteAdmin);
